import ApiWebCallEvo, {
    API_URL_USER_EMAIL_CHECK,
} from "./calls/evo-api-call";

export default class UserEmailCheckDataProvider  {

    constructor() {}

    /**
     *
     * @param email
     * @param params
     * @param headers
     */
    public async getData(email: string, params: { [key: string | number]: string | number} = {}, headers: { [key: string | number]: string | number} = {}) {


        headers["email"] = email;
        params["email"] = email;

        let apiCall = new ApiWebCallEvo(
            API_URL_USER_EMAIL_CHECK,
            params,
            headers
        );

        let res = await apiCall.makeCall();

        return res;
    }
}